<template>
	<v-card hover outlined @click='$emit("click")'>
		<v-list-item three-line>
			<v-list-item-avatar class='elevation-2' color='grey' size='80' tile v-if='icon'>
				<v-img :src='icon' contain />
			</v-list-item-avatar>
			<v-list-item-content>
				<v-list-item-title class='headline text-wrap' v-text='title' />
				<v-list-item-subtitle class='subtitle-1' v-text='subtitle'></v-list-item-subtitle>
			</v-list-item-content>
		</v-list-item>

		<v-card-text :style='textHeight' class='pt-0 mb-4'>
			<v-chip :key='title' class='caption ma-1' label outlined v-for='{title} in benefits'>
				<v-icon left>mdi-star-circle</v-icon>
				{{ title }}
			</v-chip>

			<AttachmentSection :files='files' />

			<div v-html='text' />
		</v-card-text>
	</v-card>
</template>

<script>
import AttachmentSection from '@/components/base/AttachmentSection'

export default {
	props: {
		title: String,
		subtitle: String,
		icon: String,
		text: String,
		benefits: Array,
		files: Array
	},
	components: {
		AttachmentSection
	},
	data() {
		return {
			isCollapsed: true,
		}
	},
	computed: {
		serviceText() {
			return this.isCollapsed ? this.text : this.text
		},
		textHeight() {
			return this.isCollapsed ? 'max-height: 80px' : ''
		},
	},
}
</script>

<style scoped>
.v-card__text {
	overflow: hidden !important;
}
</style>